// @flow strict

import * as React from 'react'
import { SectionWrapper, SectionThemes } from '../SectionWrapper'
import { Link } from 'gatsby'
import styles from './BusinessBankingCTABanner.module.scss'

const BusinessBankingCTABanner = () => (
  <SectionWrapper
    theme={SectionThemes.LIGHT}
    className={styles.section}
    contentClassName={styles.content}
  >
    <div className={styles.textCol}>
      <h2 className={styles.title}>Monzo Business</h2>
      <p className={styles.subtitle}>It just works, so you can too</p>
    </div>
    <div className={styles.CTACol}>
      <Link to="/business" className={styles.link}>
        Explore Monzo Business →
      </Link>
    </div>
  </SectionWrapper>
)
export default BusinessBankingCTABanner
